import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";
import { fetchM } from "../../../../utils/fetch";

class InvestigationFaqPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.props.breadcrumbs([{ label: "Podnět k prošetření" }]);
    this.loadTemplate();
  }

  async loadTemplate() {
    try {
      const response = await fetchM("/verejnost/api/sablony", {
        params: { type: "INVESTIGATION_FAQ" },
      });
      const data = await response.json();
      const content = data.content
        ? new TextDecoder("utf-8").decode(
            Uint8Array.from(atob(data.content), (c) => c.charCodeAt(0)),
          )
        : "";
      this.setState({ content, loading: false });
    } catch (e) {
      this.setState({ loading: false, error: "Nepodařilo se načíst informace." });
    }
  }

  render() {
    const { content, loading, error } = this.state;
    return (
      <div className="publicPage">
        <div className="publicPage__card">
          <div className="publicPage__content">
            {loading && <div>Načítání...</div>}
            {error && <div className="error">{error}</div>}
            {!loading && content && (
              <div
                className="investigationFaq__content publicContent"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
            <div className="investigationFaq__actions" style={{ marginTop: 16 }}>
              <Button
                type="button"
                style={styles.buttons}
                label="Podat podnět na prošetření"
                onClick={() => this.props.navigate("/verejnost/podnet/form")}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  breadcrumbs: (items) => dispatch(breadcrumbs(items)),
  navigate: (path) => dispatch(push(path)),
});

export default connect(null, mapDispatchToProps)(InvestigationFaqPage);
